import _ from 'lodash';

// A candidate role is already on the project when its name, location and — where the workspace uses them —
// practice all match an existing one.
export default function isSameRole(candidate, projectRole, practicesEnabled) {
  const sameName = _.trim(_.lowerCase(candidate.name)) === _.trim(_.lowerCase(projectRole.name));
  const sameLocation = candidate.location?.id === projectRole.location?.id;
  if (!practicesEnabled) return sameName && sameLocation;
  return sameName && sameLocation && candidate.practice?.id === projectRole.practice?.id;
}
